import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import FormDialog from "../FormDialog/FormDialog"
import db from "../../../../../db"
import { auth } from "../../../../../db"
import { toast } from 'react-toastify';


const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },

}));

const Toolbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const [op, setOp] = useState(false)
  const [tabelNumber, setTabelNumber] = useState()
  const [firstName, setFirstName] = useState()
  const [lastName, setLastName] = useState()
  const [middleName, setMiddleName] = useState()
  const [position, setPosition] = useState()
  const [department, setDepartment] = useState()
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  const [role, setRole] = useState()
  const [departmentData, setDepartmentData] = useState([])
  const [roleData, setRoleData] = useState([])

  const fields =
  {
    tabelNumber: {
      value: tabelNumber,
      func: setTabelNumber
    },
    firstName: {
      value: firstName,
      func: setFirstName
    },
    lastName: {
      value: lastName,
      func: setLastName
    },
    middleName: {
      value: middleName,
      func: setMiddleName
    },
    position: {
      value: position,
      func: setPosition
    },
    department: {
      value: department,
      func: setDepartment,
      data: departmentData
    },
    email: {
      value: email,
      func: setEmail
    },
    password: {
      value: password,
      func: setPassword
    },
    role:
    {
      value: role,
      func: setRole,
      data: roleData
    }
  }

  const handleOpen = () => {
    setOp(true)
    db.ref('InfoCenter/Departments').once('value').then(snap => {
      if (snap.val()) {
        setDepartmentData(snap.val())
      }
    })
    db.ref('InfoCenter/Roles').once('value').then(snap => {
      if (snap.val()) {
        setRoleData(snap.val())
      }
    })
  }

  const handleAdd = () => {

    if (tabelNumber && firstName && lastName && middleName && position && department && email && password && role) {
      auth.createUserWithEmailAndPassword(email, password).then(a => {
        db.ref().child('User/' + a.user.uid).set({
          tabelNumber: tabelNumber,
          firstName: firstName,
          lastName: lastName,
          middleName: middleName,
          position: position,
          department: department,
          email: email,
          role: role,
          active: true,
          image: "none"
        }).then(() => {
          setTabelNumber()
          setFirstName()
          setLastName()
          setMiddleName()
          setPosition()
          setDepartment()
          setEmail()
          setRole()
          setPassword()
          toast.success('Ավելացված է');
          setOp(false)
        })
      })
    } else {
      toast.error('Լրացրեք բոլոր դաշտերը')
    }
  }



  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <h2>Օգտագործողներ</h2>
      <div className={classes.row}>
        <span className={classes.spacer} />
        <Button
          // className={classes.btn}
          color="primary"
          variant="contained"
          onClick={handleOpen}
          style={{ marginBottom: "10px" }}
        >
          Ավելացնել
                        </Button>
        <FormDialog op={op} setOp={setOp} title="Ավելացնել օգտագործող" func={handleAdd} fields={fields} pass={true} />

      </div>

    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
